import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'kh-main-root',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    imports: [RouterOutlet]
})
export class MainComponent {

    constructor() { }
}
